/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

import dayjs from "dayjs"
// other
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import LabelFormRow from "../../../components/LabelFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { 区分分類コード } from "../../../constant/enum/codes"
import { e休日区分 } from "../../../constant/enum/master"
import {
  e乗務員所定労働時間区分,
  e勤怠区分,
  e勤怠区分名称,
} from "../../../constant/enum/unko"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SyukkinboService from "../../../service/attendance/syukkinbo_v2/syukkinboService"
import KubunService from "../../../service/master/kubun/kubunService"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import { TApiResponse } from "../../../service/TApiResponse"
import pageHelper from "../../../ts/helpers/pageHelper"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import DigitachoGrid from "./DigitachoGrid"
import TimeCardGrid from "./TimeCardGrid"
import {
  TZyomuinHibetuKintai,
  TZyomuinSyukkinboDigitachoKintaiRes,
  TZyomuinSyukkinboDigitachoGetReq,
  TZyomuinSyukkinboYukyuByMonthGetRes,
  TSyukkinboDakokuGetRes,
  TSyukkinboGetReq,
  TZikanSyuseiListDetailPutReq,
  TZikanSyuseiListPutReq,
} from "../../../service/attendance/syukkinbo_v2/TZyomuinSyukkinbo"
import dateUtil from "../../../ts/util/dateUtil"
import SummaryTimeGrid, { T勤怠集計 } from "./SummaryTimeGrid"
import {
  calc勤怠リスト,
  create勤務区分ItemSource,
  create勤務日数総計,
  create勤怠時間総計,
  e労務警告区分,
  乗務員出勤簿ExcelFormat,
  乗務員出勤簿PdfFormat,
  出勤無し勤怠区分List,
} from "./zyomuinSyukkinboUtil"
import SummaryWorkingDayGrid, { T勤怠日数集計 } from "./SummaryWorkingDayGrid"
import DigitachoEditModal from "./DigitachoEditModal"
import RoumuKeikokuModal from "./RoumuKeikokuModal"

//#region [type]

export type T勤怠リスト = TZyomuinHibetuKintai & {
  曜日?: String
  /**
   * HH:mm表記
   */
  str始業時刻?: string
  /**
   * HH:mm表記
   */
  str終業時刻?: string
  /**
   * HH:mm表記
   */
  str休憩時間?: string
  /**
   * HH:mm表記
   */
  str休息時間?: string
  /**
   * HH:mm表記
   */
  str拘束時間?: string
  /**
   * HH:mm表記
   */
  str勤務時間?: string
  /**
   * HH:mm表記
   */
  str残業時間?: string
  /**
   * HH:mm表記
   */
  str深夜時間?: string
  /**
   * HH:mm表記
   */
  str休出時間?: string
  row_id: symbol
  複数行フラグ: number
}

//#endregion

/**
 * 出勤簿
 * @returns
 */
const ZyomuinSyukkinbo = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: 所属_社員ID, date: 年月 } = useParams<{
    id: string
    date: string
  }>()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  let gridId = "ZyomuinSyukkinbo_GridId"

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)
  //#region [method]

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyukkinboGetReq => {
    return {
      社員ID: parseInt(所属_社員ID),
      年月,
    }
  }
  /**
   * 検索条件オブジェクトを生成
   */
  const createDigitachoSearchCondition =
    (): TZyomuinSyukkinboDigitachoGetReq => {
      return {
        社員ID: parseInt(所属_社員ID),
        年月: dayjs(年月).startOf("month").format("YYYY/MM/DD"),
      }
    }
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TZyomuinHibetuKintai>) => {
    const bindItems: T勤怠リスト[] = data.map((item) => {
      return {
        ...item,
        row_id: Symbol(),
        複数行フラグ: 0,
        削除対象フラグ: 0,
      }
    })
    bindItems.forEach((d) => {
      if (bindItems.filter((f) => f.勤務日 === d.勤務日).length > 1) {
        d.複数行フラグ = 1
      }
    })
    return new wjCore.CollectionView(bindItems, {
      calculatedFields: {
        曜日: (i: T勤怠リスト) => {
          return dayjs(i.勤務日).format("ddd")
        },
        勤怠情報_表示勤怠区分: (i: T勤怠リスト) => {
          if (!区分ItemSource) return ""
          // 区分マスタの分類コード、社員区分でfilterする。
          // 勤怠区分と区分コードを比較するとuniqueになるので名称を取得する。
          const tmp = 区分ItemSource
            ?.filter((d) => d.分類コード === "U0002")
            .filter((m) => m.数値1 === parseInt(社員区分!) || m.数値1 === 0)
            .filter((k) => k.区分コード === i.勤怠区分コード)
          try {
            if (tmp) {
              const item = tmp[0].名称2
              return item
            }
          } catch (error) {
            return ""
          }
        },
        str始業時刻: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.始業時刻 ?? "")
            ? dateUtil.toTimeSpanString(item.始業時刻 ?? 0)
            : "",
        str終業時刻: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.終業時刻 ?? "")
            ? dateUtil.toTimeSpanString(item.終業時刻 ?? 0)
            : "",
        str休憩時間: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.休憩時間 ?? "")
            ? dateUtil.toTimeSpanString(item.休憩時間!)
            : "",
        str休息時間: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.休息時間 ?? "")
            ? dateUtil.toTimeSpanString(item.休息時間!)
            : "",
        str拘束時間: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.拘束時間 ?? "")
            ? dateUtil.toTimeSpanString(item.拘束時間!)
            : "",
        str勤務時間: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.勤務時間 ?? "")
            ? dateUtil.toTimeSpanString(item.勤務時間!)
            : "",
        str残業時間: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.残業時間 ?? "")
            ? dateUtil.toTimeSpanString(item.残業時間!)
            : "",
        str深夜時間: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.深夜時間 ?? "")
            ? dateUtil.toTimeSpanString(item.深夜時間!)
            : "",
        str休出時間: (item: T勤怠リスト) =>
          !wjCore.isNullOrWhiteSpace(item.休出時間 ?? "")
            ? dateUtil.toTimeSpanString(item.休出時間!)
            : "",
        労務警告List: (item: T勤怠リスト) => {
          const 労務警告List: string[] = []
          if (item.勤怠警告1 === 1) {
            労務警告List.push(e労務警告区分.出勤打刻未存在かつデジタコ出庫存在)
          }
          if (item.勤怠警告2 === 1) {
            労務警告List.push(e労務警告区分.出勤打刻存在かつ退勤打刻未存在)
          }
          if (item.勤怠警告3 === 1) {
            労務警告List.push(e労務警告区分.電話点呼時中間点呼未存在)
          }
          if (item.勤怠警告4 === 1) {
            労務警告List.push(e労務警告区分.休息3時間未満)
          }
          if (item.勤怠警告5 === 1) {
            // 拘束時間を確認し14時間以上の場合に31
            const 拘束時間 = !Number.isNaN(item.拘束時間)
              ? parseInt(item.拘束時間 ?? "0")
              : 0
            const hourMilliSeconds = 1000 * 60 * 60
            if (hourMilliSeconds * 14 < 拘束時間) {
              労務警告List.push(e労務警告区分.拘束時間14時間超過)
            } else {
              労務警告List.push(e労務警告区分.拘束時間13時間超過)
            }
          }
          if (item.勤怠警告6 === 1) {
            労務警告List.push(e労務警告区分.連続走行時間4時間以上)
          }
          return 労務警告List
        },
        労務警告文字: (item: T勤怠リスト) => {
          if (item.勤怠警告6 === 1) {
            return e労務警告区分.連続走行時間4時間以上
          }
          if (item.勤怠警告5 === 1) {
            // 拘束時間を確認し14時間以上の場合に31
            const 拘束時間 = !Number.isNaN(item.拘束時間)
              ? parseInt(item.拘束時間 ?? "0")
              : 0
            const hourMilliSeconds = 1000 * 60 * 60
            if (hourMilliSeconds * 14 < 拘束時間) {
              return e労務警告区分.拘束時間14時間超過
            }
          }
          if (item.勤怠警告4 === 1) {
            return e労務警告区分.休息3時間未満
          }
          if (item.勤怠警告3 === 1) {
            return e労務警告区分.電話点呼時中間点呼未存在
          }

          if (item.勤怠警告1 === 1) {
            return e労務警告区分.出勤打刻未存在かつデジタコ出庫存在
          }
          if (item.勤怠警告5 === 1) {
            return e労務警告区分.拘束時間13時間超過
          }
          if (item.勤怠警告2 === 1) {
            return e労務警告区分.出勤打刻存在かつ退勤打刻未存在
          }
          return ""
        },
      },
    })
  }
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createDigiTachoCollectionView = (
    data: Array<TZyomuinSyukkinboDigitachoKintaiRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        str始業時刻: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.始業時刻 ?? 0),
        str終業時刻: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.終業時刻 ?? 0),
        str勤務時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.勤務時間 ?? 0),
        str残業時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.残業時間 ?? 0),
        str深夜時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.深夜時間 ?? 0),
        str休憩時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.休憩時間 ?? 0),
        str休息時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.休息時間 ?? 0),
        str拘束時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.拘束時間 ?? 0),
        str荷積時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.荷積時間 ?? 0),
        str荷卸時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.荷卸時間 ?? 0),
        str待機時間: (item: TZyomuinSyukkinboDigitachoKintaiRes) =>
          dateUtil.toTimeSpanString(item.待機時間 ?? 0),
      },
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createDakokuCollectionView = (data: TSyukkinboDakokuGetRes[]) => {
    return new wjCore.CollectionView(data, {
      sortDescriptions: ["勤務日"],
      groupDescriptions: [
        new wjCore.PropertyGroupDescription(
          "勤務日",
          (i: TSyukkinboDakokuGetRes, property) => {
            return dayjs(i.勤務日).format("MM/DD")
          }
        ),
      ],
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition: TSyukkinboGetReq) => {
    const syukkinboService = new SyukkinboService()
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TSyukkinboGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成parse
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    try {
      const res = await syukkinboService.zyomuinGetIndividualList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      set部所コード(res.data.部所コード)
      set部所名(res.data.部所名)
      set社員番号(res.data.社員コード)
      set氏名(res.data.社員氏名)
      set社員区分(res.data.社員区分コード)
      // TimeSpanの返却値をdayjsに合わせるため加工
      let res勤怠リスト: TZyomuinHibetuKintai[] = res.data.勤怠リスト
      const 勤怠リストitems: TZyomuinHibetuKintai[] = []
      res勤怠リスト.forEach((d) => {
        const 勤怠リストitem: TZyomuinHibetuKintai = {
          ...d,
          乗務員日別勤怠ID: d.乗務員日別勤怠ID,
          勤務日: d.勤務日,
          勤怠区分コード: d.勤怠区分コード,
          // 返却値がミリ秒のため、日付型に変換してからHH:mmの形に修正
          タイムカード出勤時刻: d.タイムカード出勤時刻
            ? dayjs(
                dayjs(d.勤務日).add(parseInt(d.タイムカード出勤時刻), "ms")
              ).format("HH:mm")
            : "",
          タイムカード退勤時刻: d.タイムカード退勤時刻
            ? dayjs(
                dayjs(d.勤務日).add(parseInt(d.タイムカード退勤時刻), "ms")
              ).format("HH:mm")
            : "",
          日曜フラグ: d.日曜フラグ,
          祝日フラグ: d.祝日フラグ,
          備考: d.備考,
          更新日時: d.更新日時,
        }
        勤怠リストitems.push(勤怠リストitem)
      })

      setGridData({ data: createCollectionView(勤怠リストitems) })

      // 集計データを加工して登録
      setSummaryTimeGridData(create勤怠時間総計(res.data.勤怠リスト))

      holidayList.splice(0, holidayList.length)

      const kyuzituRes = await new KyuzituService().getList({
        検索年: currentSearchCondition.年月,
      })
      kyuzituRes.data
        .filter((d) => d.休日区分コード === e休日区分.会社休日)
        .forEach((i) => {
          holidayList.push({
            休日: i.休日日付,
          })
        })
      kyuzituRes.data
        .filter(
          (d) =>
            d.休日区分コード === e休日区分.所定休日 ||
            d.休日区分コード === e休日区分.祝日
        )
        .forEach((i) => {
          syoteiHolidayList.push({
            休日: i.休日日付,
          })
        })

      // 有休データを取得
      const yukyuRes = await syukkinboService.zyomuinGetYukyuByMonthList(
        currentSearchCondition
      )
      set有給残数(yukyuRes.data)
      setSummaryWorkingDayGridData(
        create勤務日数総計(res.data.勤怠リスト, yukyuRes.data)
      )

      // 打刻データ取得
      const dakokuRes = await syukkinboService.getDakokuList(
        currentSearchCondition
      )
      const dakokuData: TSyukkinboDakokuGetRes[] = []
      dakokuRes.data.forEach((d) => {
        const 打刻リストitem: TSyukkinboDakokuGetRes = {
          勤怠打刻ID: d.勤怠打刻ID,
          社員ID: d.社員ID,
          勤務日: dayjs(d.勤務日).format("MM/DD"),
          出退勤区分ID: d.出退勤区分ID,
          出退勤区分コード: d.出退勤区分コード,
          出退勤区分名称1: d.出退勤区分名称1,
          出勤時間: d.出勤時間
            ? dayjs(dayjs(d.勤務日).add(parseInt(d.出勤時間), "ms")).format(
                "HH:mm"
              )
            : "",
          退勤時間: d.退勤時間
            ? dayjs(dayjs(d.勤務日).add(parseInt(d.退勤時間), "ms")).format(
                "HH:mm"
              )
            : "",
          出退勤時刻: d.出退勤時刻,
          削除フラグ: d.削除フラグ,
          作成日時: d.作成日時,
        }
        dakokuData.push(打刻リストitem)
      })
      setDakokuGridData({ data: createDakokuCollectionView(dakokuData) })

      // デジタコデータ取得

      try {
        const digiTachoRes = await syukkinboService.getDigiTachoList(
          createDigitachoSearchCondition()
        )

        // 検索結果をstateにセット
        setDigiTachoGridData({
          data: createDigiTachoCollectionView(digiTachoRes.data, pageSize),
        })
      } catch (error) {
        // dispatch(setAlerts(error))
        dispatch(setWarningAlerts(["エラー表示"]))
      } finally {
        setIsDigiTachoSearching(false) // 検索中状態に遷移
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索状態切り替え
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      switch (c.binding) {
        case "勤務日":
        case "曜日":
          columnHeaders.setCellData(0, index, "日付")
          break
        case "勤怠区分コード":
        case "タイムカード出勤時刻":
        case "タイムカード退勤時刻":
          columnHeaders.setCellData(0, index, "タイムカード")
          break
        case "str始業時刻":
        case "str終業時刻":
          columnHeaders.setCellData(0, index, "デジタコ")
          break
        case "str勤務時間":
        case "str残業時間":
        case "str深夜時間":
        case "str休出時間":
        case "str拘束時間":
        case "str休憩時間":
        case "str休息時間":
          columnHeaders.setCellData(0, index, "就労時間")
          break
        case "労務警告文字":
          columnHeaders.setCellData(0, index, "労務警告")
          break
        case "安全会議":
          columnHeaders.setCellData(0, index, "安全会議")
          break
        case "運行外業務記号区分コード":
          columnHeaders.setCellData(0, index, "運行外業務")
          break
        case "備考":
          columnHeaders.setCellData(0, index, "備考")
          break
        case "日別勤怠ID":
          columnHeaders.setCellData(0, index, "削除")
          break
        default:
          const cellData = columnHeaders.getCellData(1, index, true)
          columnHeaders.setCellData(0, index, cellData)
          break
      }
      c.allowMerging = true
      c.align = "center"
    })

    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.cellEditEnding.addHandler(cellEditEnding)
    grid.cellEditEnded.addHandler(cellEditEnded)
    grid.pastingCell.addHandler(pastingCell)

    grid.refresh()
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    switch (col.binding as keyof T勤怠リスト) {
      case "タイムカード出勤時刻":
      case "タイムカード退勤時刻":
        if (s.getCellData(e.row, e.col, false)) {
          let 時間: string = s.getCellData(e.row, e.col, false)
          時間 = 時間.replaceAll(":", "")
          s.setCellData(e.row, e.col, 時間)
        }
        break
    }
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const cellEditEnding = async (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellEditEndingEventArgs
  ) => {
    let col = s.columns[e.col]
    switch (col.binding as keyof T勤怠リスト) {
      case "タイムカード出勤時刻":
      case "タイムカード退勤時刻":
        if (s.activeEditor && s.activeEditor.value) {
          if (!IsTimeNumber(s.activeEditor.value)) {
            e.cancel = true
          }
          break
        }
        break
      case "勤怠区分コード":
        if (wjCore.isNullOrWhiteSpace(s?.activeEditor?.value ?? "")) return

        if (s.activeEditor.value !== e勤怠区分名称[e.data]) {
          console.log("変更")

          if (s.activeEditor.value === e勤怠区分名称[e勤怠区分.所定出勤]) {
            // 所定休日の場合、勤務時間がそのまま残業時間となる
            const data = e.getRow()?.dataItem as T勤怠リスト
            data.残業時間 = data.勤務時間
          } else {
            const data = e.getRow()?.dataItem as T勤怠リスト
            const 勤務日 = dayjs(data.勤務日)
            const 基準労働時間 =
              区分ItemSource?.find(
                (e) =>
                  e.分類コード ===
                    区分分類コード.運行管理_勤怠.乗務員所定労働時間区分 &&
                  e.区分コード === e乗務員所定労働時間区分.基準労働時間
              )?.数値1 ?? 0
            const 基準労働ミリ秒 = 基準労働時間 * 60 * 60 * 1000

            const 勤務時間 = parseInt(data.勤務時間 ?? "0")
            const 残業時間 = 勤務時間 - 基準労働ミリ秒
            console.log(勤務日.day())
            if (勤務時間 > 0 && 勤務日.day() === 0) {
              data.残業時間 = "0"
              data.休出時間 = 勤務時間.toString()
            } else if (残業時間 > 0) {
              data.休出時間 = "0"
              data.残業時間 = 残業時間.toString()
            } else {
              data.休出時間 = "0"
              data.残業時間 = "0"
            }
          }
        }
        break
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    const dataItem = e.getRow().dataItem as T勤怠リスト
    switch (col.binding as keyof T勤怠リスト) {
      case "タイムカード出勤時刻":
        if (s.getCellData(e.row, e.col, false)) {
          let newValue: string = s.getCellData(e.row, e.col, false)
          s.setCellData(e.row, e.col, convTimeString(newValue))
        }
        break
      case "タイムカード退勤時刻":
        if (s.getCellData(e.row, e.col, false)) {
          let newValue: string = s.getCellData(e.row, e.col, false)
          const 退勤時間 = convTimeString(newValue)
          s.setCellData(e.row, e.col, 退勤時間)
        }
        // TODO: 自動計算は一時封印
        if (false) {
          calc勤怠リスト(dataItem, 区分ItemSource ?? [])
        }
        setIsGridRefreshed(true)
        break

      case "勤怠区分コード":
        setIsGridRefreshed(true)
        break
    }
  }

  /**
   * ペーストイベント
   */
  const pastingCell = (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    const pastingData = e.data
    let col = s.columns[e.col]
    if (pastingData) {
      switch (col.binding as keyof T勤怠リスト) {
        case "タイムカード出勤時刻":
        case "タイムカード退勤時刻":
          if (!IsTimeNumber(pastingData)) {
            e.cancel = true
          }
          e.data = convTimeString(pastingData)
          break
      }
    }
  }

  /**
   * 時間文字列に変換
   * @param s:any
   * @return hhmm、hh:mmの場合はtrue、違う場合はfalse
   */
  const convTimeString = (s: any) => {
    let resultString = s.replaceAll(":", "")
    // 0埋め
    resultString = ("0000" + resultString).slice(-4)
    resultString = resultString.slice(0, 2) + ":" + resultString.slice(-2)
    return resultString
  }

  /**
   * 時間を示す数値か確認する
   * @param s:any
   * @return hhmm、hh:mmの場合はtrue、違う場合はfalse
   */
  const IsTimeNumber = (s: any) => {
    if (s === undefined || s === null) {
      return false
    }
    const inputData = s.replaceAll(":", "")
    const inputNumber = parseInt(inputData)
    // 文字列の場合は入力キャンセル
    // .や-や0x、0oもキャンセル
    if (
      inputNumber === null ||
      isNaN(inputNumber) ||
      (!s.match(/:/) && s.match(/[^0-9]+/))
    ) {
      return false
    }
    // ２ケタ以下、５ケタ以上の場合は入力キャンセル
    if (4 < inputData.length || inputData.length < 3) {
      return false
    }
    // 数値に変換し、下2桁を分、上2桁を時間とする
    const h = Math.floor(inputNumber / 100)
    const m = inputNumber % 100
    // 時間が23より大きい場合は入力キャンセル
    if (23 < h) {
      return false
    }
    if (59 < m) {
      return false
    }
    return true
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    const cellBinding = e.getColumn().binding as keyof (T勤怠リスト & {
      労務警告文字: string
    })
    const targetRow = e.getRow()
    const dataItem: T勤怠リスト = targetRow.dataItem

    if (e.panel === f.cells) {
      targetRow.isReadOnly = dataItem.削除フラグ === 1
      switch (cellBinding) {
        case "タイムカード出勤時刻":
        case "タイムカード退勤時刻":
          if (
            出退勤時刻不正List.current != null &&
            出退勤時刻不正List.current.length > 0
          ) {
            const is不正Data = 出退勤時刻不正List.current.find(
              (d) => d === dataItem.row_id
            )
              ? true
              : false
            wjCore.toggleClass(e.cell, "data-warning", is不正Data)
          }
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            dataItem.削除フラグ === 1
          )
          break
        case "str終業時刻":
          wjCore.toggleClass(
            e.cell,
            "fw-bold",
            !dayjs(dataItem.勤務日).isSame(dataItem.終業日付, "date")
          )
          break
        case "勤怠区分コード":
          if (
            勤怠区分不正List.current != null &&
            勤怠区分不正List.current.length > 0
          ) {
            const is不正Data = 勤怠区分不正List.current.includes(
              dataItem.row_id
            )
            wjCore.toggleClass(e.cell, "data-warning", is不正Data)
          }
          if (e勤怠区分.出勤 === dataItem.勤怠区分コード && e.row > 0) {
            const beforeRow = f.rows[e.row - 1]
            const beforeDataItem: T勤怠リスト = beforeRow.dataItem
            wjCore.toggleClass(
              e.cell,
              "bg-pastelGreen",
              !wjCore.isNullOrWhiteSpace(beforeDataItem.str休息時間 ?? "") &&
                beforeDataItem.str休息時間 !== "00:00" &&
                wjCore.isNullOrWhiteSpace(dataItem.タイムカード出勤時刻 ?? "")
            )
          }
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            dataItem.削除フラグ === 1
          )
          wjCore.toggleClass(
            e.cell,
            "text-green",
            e勤怠区分.特別休暇 === dataItem.勤怠区分コード
          )
          wjCore.toggleClass(
            e.cell,
            "text-blue",
            e勤怠区分.所定休日 === dataItem.勤怠区分コード ||
              e勤怠区分.所定出勤 === dataItem.勤怠区分コード
          )
          wjCore.toggleClass(
            e.cell,
            "text-red",
            [
              e勤怠区分.有給休暇,
              e勤怠区分.午前半休,
              e勤怠区分.午後半休,
              e勤怠区分.休日,
              e勤怠区分.振替休日,
              e勤怠区分.代休,
              e勤怠区分.欠勤,
            ].some((e) => e === dataItem.勤怠区分コード)
          )
          // 育介休暇・育介半休は事務員出勤簿と同じ文字色に合わせる（KAIROS-1125）
          // 事務員出勤簿は kubunColors.u0002Variants で 50/51 → done を指定しており、
          // 本画面は他の勤怠区分もクラス名直書きのため text-done を直接指定する
          wjCore.toggleClass(
            e.cell,
            "text-done",
            [e勤怠区分.育介休暇, e勤怠区分.育介半休].some(
              (e) => e === dataItem.勤怠区分コード
            )
          )

          break
        case "str休憩時間":
        case "str休息時間":
        case "str拘束時間":
        case "str勤務時間":
        case "str残業時間":
        case "str深夜時間":
        case "str休出時間":
          wjCore.toggleClass(
            e.cell,
            "text-secondary",
            e.cell.innerText === "00:00"
          )
          if (
            dataItem.始業時刻 == null &&
            dataItem.終業時刻 == null &&
            e.cell.innerText === "00:00"
          ) {
            e.cell.innerText = ""
          }
          break
        case "労務警告文字":
          const data = f.getCellData(e.row, e.col, false)

          switch (data as (typeof e労務警告区分)[keyof typeof e労務警告区分]) {
            case e労務警告区分.出勤打刻未存在かつデジタコ出庫存在:
            case e労務警告区分.電話点呼時中間点呼未存在:
            case e労務警告区分.休息3時間未満:
            case e労務警告区分.拘束時間14時間超過:
            case e労務警告区分.連続走行時間4時間以上:
              wjCore.toggleClass(e.cell, "bg-red", true)
              wjCore.toggleClass(e.cell, "bg-yellow", false)
              wjCore.toggleClass(e.cell, "fw-bold", true)
              break
            case e労務警告区分.出勤打刻存在かつ退勤打刻未存在:
            case e労務警告区分.拘束時間13時間超過:
              wjCore.toggleClass(e.cell, "bg-red", false)
              wjCore.toggleClass(e.cell, "bg-yellow", true)
              wjCore.toggleClass(e.cell, "fw-bold", true)
              break
            default:
              wjCore.toggleClass(e.cell, "bg-red", false)
              wjCore.toggleClass(e.cell, "bg-yellow", false)
              wjCore.toggleClass(e.cell, "fw-bold", false)
              break
          }
          break
        case "修正フラグ":
          wjCore.toggleClass(e.cell, "bg-pink", dataItem?.修正フラグ === 1)
          break
        case "備考":
        case "曜日":
        case "勤務日":
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            dataItem.削除フラグ === 1
          )
          break
      }
    }

    if (e.panel.cellType === wjcGrid.CellType.ColumnHeader) {
      // 特定のセルを除外する条件
      if (cellBinding !== "曜日") {
        wjCore.addClass(e.cell, "fs-5")
      }
    }
  }

  /**
   * 行挿入
   */
  const addNewRow = () => {
    if (flexGrid) {
      if (flexGrid.selection) {
        const rowIndex = flexGrid.selection.row
        const selectedRow: T勤怠リスト = flexGrid.rows[rowIndex].dataItem
        const newItem: T勤怠リスト = {
          勤務日: selectedRow.勤務日,
          row_id: Symbol(),
          複数行フラグ: 2,
          削除フラグ: 0,
        }
        flexGrid.collectionView.sourceCollection.splice(
          rowIndex + 1,
          0,
          newItem
        )

        flexGrid.collectionView.refresh()
      }
    }
  }
  const deleteNewRow = () => {
    if (deleteRowIndex) {
      gridData.data.removeAt(deleteRowIndex)
      flexGrid?.collectionView.refresh()
    }
    setIsDeleteNewRowConfirmModalShow(false)
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let messages: string[] = []
    let isError = false
    // エラーチェック
    const 出退勤Valid = 出退勤Validate()
    isError = 出退勤Valid.hasError === true ? true : isError
    messages.push(...出退勤Valid.messages)
    if (isError) {
      dispatch(setWarningAlerts(messages))
      flexGrid?.refresh()
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * エラークリア
   */
  const clearError = () => {
    dispatch(clearAlert())
    出退勤時刻不正List.current.splice(0)
    勤怠区分不正List.current.splice(0)
    運行外区分不正List.current.splice(0)
  }

  /**
   * 出退勤の入力チェック
   */
  const 出退勤Validate = () => {
    let 出退勤エラーチェック = false
    let 勤怠区分エラーチェック = false
    let 運行外区分エラーチェック = false
    let エラーメッセージList: string[] = []
    const gData: T勤怠リスト[] = gridData.data.items

    gData.forEach((d, i) => {
      // 削除対象はエラーを無視する
      if (d.削除フラグ === 1) return
      const 出勤時刻 = dayjs(
        dayjs(d.勤務日).format("YYYY/MM/DD ") + d.タイムカード出勤時刻
      )
      const 退勤時刻 = dayjs(
        dayjs(d.勤務日).format("YYYY/MM/DD ") + d.タイムカード退勤時刻
      )

      // 出退勤時刻不正チェック
      if (
        d.タイムカード出勤時刻 &&
        d.タイムカード退勤時刻 &&
        出勤時刻 >= 退勤時刻
      ) {
        if (!出退勤エラーチェック) {
          出退勤エラーチェック = true
          エラーメッセージList.push("出退勤時刻が不正です。")
        }
        出退勤時刻不正List.current.push(d.row_id)
      }

      // 勤怠区分不正チェック
      if (
        d.勤怠区分コード == null &&
        (d.タイムカード出勤時刻 || d.タイムカード退勤時刻)
      ) {
        if (!勤怠区分エラーチェック) {
          勤怠区分エラーチェック = true
          エラーメッセージList.push("勤怠区分が入力されていません。")
        }
        勤怠区分不正List.current.push(d.row_id)
      }

      // 同一日勤怠区分チェック
      if (i !== 0) {
        // 削除フラグONのレコード以外が対象
        let 直前レコード = gData[i - 1]
        for (
          let チェック対象Index = i - 1;
          0 <= チェック対象Index;
          チェック対象Index--
        ) {
          直前レコード = gData[チェック対象Index]
          if (直前レコード.削除フラグ !== 1) break
        }

        if (
          dayjs(d.勤務日).diff(直前レコード.勤務日, "d") === 0 &&
          直前レコード.勤怠区分コード !== d.勤怠区分コード
        ) {
          if (!勤怠区分エラーチェック) {
            勤怠区分エラーチェック = true
            エラーメッセージList.push(
              "同一勤務内は同じ勤怠区分を選択してください"
            )
          }
          const 同一日List = gData.filter(
            (e) => dayjs(d.勤務日).diff(e.勤務日, "d") === 0
          )
          勤怠区分不正List.current.push(...同一日List.map((e) => e.row_id))
        }
      }

      // 休日チェック
      if (
        出勤無し勤怠区分List.find((e) => e === d.勤怠区分コード) &&
        (d.タイムカード出勤時刻 || d.タイムカード退勤時刻)
      ) {
        if (!勤怠区分エラーチェック) {
          勤怠区分エラーチェック = true
          エラーメッセージList.push("出退勤時刻が登録できない勤怠区分です。")
        }
        勤怠区分不正List.current.push(d.row_id)
      }
      // 所定出勤チェック
      if (
        e勤怠区分.所定出勤 === d.勤怠区分コード &&
        (wjCore.isNullOrWhiteSpace(d.勤務時間 ?? "") || d.勤務時間 === "0")
      ) {
        if (!勤怠区分エラーチェック) {
          勤怠区分エラーチェック = true
          エラーメッセージList.push(
            "所定出勤が選択されていますが勤務時間が入力されていません。"
          )
        }
        勤怠区分不正List.current.push(d.row_id)
      }
      // 勤務時間未入力チェック
      if (
        d.タイムカード出勤時刻 &&
        d.タイムカード退勤時刻 &&
        (wjCore.isNullOrWhiteSpace(d.勤務時間 ?? "") || d.勤務時間 === "0")
      ) {
        if (!勤怠区分エラーチェック) {
          勤怠区分エラーチェック = true
          エラーメッセージList.push(
            "出退勤が入力されていますが勤務時間が入力されていません。"
          )
        }
        出退勤時刻不正List.current.push(d.row_id)
      }
    })
    return {
      hasError:
        出退勤エラーチェック ||
        勤怠区分エラーチェック ||
        運行外区分エラーチェック,
      messages: エラーメッセージList,
    }
  }

  /**
   * 登録・更新
   */
  const submit = async () => {
    try {
      const service = new SyukkinboService()
      let res: TApiResponse<boolean>

      res = await service.zyomuinPutList(getData())

      if (res) {
        isPrompt.current = false
        search(createSearchCondition())
        dispatch(setAlerts(res))
        showInfoToast(`出勤簿の更新が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 更新用データ取得
   */
  const getData = () => {
    const putList: TZikanSyuseiListDetailPutReq[] = []
    const gData: T勤怠リスト[] = gridData.data.items

    gData.forEach((r) => {
      const str出勤時刻 = dayjs(r.タイムカード出勤時刻).isValid()
        ? dayjs(r.タイムカード出勤時刻)
        : dayjs(dayjs(r.勤務日).format("YYYY/MM/DD ") + r.タイムカード出勤時刻)
      const str退勤時刻 = dayjs(r.タイムカード退勤時刻).isValid()
        ? dayjs(r.タイムカード退勤時刻)
        : dayjs(dayjs(r.勤務日).format("YYYY/MM/DD ") + r.タイムカード退勤時刻)

      let kintaiData: TZikanSyuseiListDetailPutReq = {
        乗務員日別勤怠ID: r.乗務員日別勤怠ID,
        勤務日: r.勤務日!,
        勤怠区分コード: r.勤怠区分コード,
        // HH:mmの文字列からミリ秒に変換するため、一度出勤日+時刻を文字列連結して
        //「YYYY/MM/DD HH:mm」の形にしてから、diffを使って時刻のミリ秒を取得する
        // （勤務日は「YYYY/MM/DD 00:00」の値のため、出勤時刻を合わせた文字列のDiffを取れば
        // 該当時刻のミリ秒が取得できる
        タイムカード出勤時刻: r.タイムカード出勤時刻
          ? dayjs(
              dayjs(r.勤務日).format("YYYY/MM/DD ") +
                str出勤時刻.format("HH:mm")
            ).diff(dayjs(r.勤務日))
          : undefined,
        タイムカード退勤時刻: r.タイムカード退勤時刻
          ? dayjs(
              dayjs(r.勤務日).format("YYYY/MM/DD ") +
                str退勤時刻.format("HH:mm")
            ).diff(dayjs(r.勤務日))
          : undefined,
        始業日付: r.始業日付,
        始業時刻: r.始業時刻,
        終業日付: r.終業日付,
        終業時刻: r.終業時刻,
        休憩時間: r.休憩時間,
        休息時間: r.休息時間,
        拘束時間: r.拘束時間,
        勤務時間: r.勤務時間,
        残業時間: r.残業時間,
        深夜時間: r.深夜時間,
        休出時間: r.休出時間,
        削除フラグ: r.削除フラグ,
        修正フラグ: r.修正フラグ,
        備考: r.備考,
        休日フラグ: r.勤怠区分コード ? 0 : 1,
        更新日時: r.更新日時,
      }

      putList.push(kintaiData)
    })

    let putData: TZikanSyuseiListPutReq = {
      年月,
      部所: 部所コード ?? "",
      氏名: 氏名 ?? "",
      社員番号: 社員番号 ?? "",
      社員区分: 社員区分 ?? "",
      勤怠リスト: putList!,
    }
    return putData
  }

  /**
   * 編集ボタンクリック
   */
  const editButtonClickHandler =
    (
      context: TWijmoCellTemplateContext<T勤怠リスト>
    ): React.MouseEventHandler<HTMLButtonElement> =>
    (e) => {
      set選択行(context.row)
      set編集勤怠情報(context.item)
      setIsDigitachoEditModalShow(true)
    }

  /**
   * 編集ボタンクリック
   */
  const roumuKeikokuButtonClickHandler =
    (
      context: TWijmoCellTemplateContext<T勤怠リスト>
    ): React.MouseEventHandler<HTMLButtonElement> =>
    (e) => {
      set選択行(context.row)
      setIs労務警告ModalShow(true)
    }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(31)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })

  const [summaryTimeGridData, setSummaryTimeGridData] = useState<T勤怠集計[]>(
    []
  )

  const [summaryWorkingDayGridData, setSummaryWorkingDayGridData] = useState<
    T勤怠日数集計[]
  >([])

  const [pageNumber, setPageNumber] = useState<number>(0)
  const [digiTachoGridData, setDigiTachoGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })

  // 打刻リスト用グリッド
  const [dakokuGridData, setDakokuGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [, setIsDigiTachoSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [dataInitialized, setDataInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [部所コード, set部所コード] = useState<string>()
  const [部所名, set部所名] = useState<string>()
  const [氏名, set氏名] = useState<string>()
  const [社員番号, set社員番号] = useState<string>()
  const [社員区分, set社員区分] = useState<string>()
  const [有給残数, set有給残数] =
    useState<TZyomuinSyukkinboYukyuByMonthGetRes>()

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [holidayList] = useState<Array<{ 休日: string }>>([])
  const [syoteiHolidayList] = useState<Array<{ 休日: string }>>([])

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 編集モーダル処理
  const [編集勤怠情報, set編集勤怠情報] = useState<T勤怠リスト>()
  const [isDigitachoEditModalShow, setIsDigitachoEditModalShow] =
    useState(false)

  // エラーチェック用
  const 出退勤時刻不正List = useRef<Symbol[]>([])
  const 勤怠区分不正List = useRef<Symbol[]>([])
  const 運行外区分不正List = useRef<Symbol[]>([])

  const [is労務警告ModalShow, setIs労務警告ModalShow] = useState(false)
  const [isDeleteNewRowConfirmModalShow, setIsDeleteNewRowConfirmModalShow] =
    useState(false)
  const [deleteRowIndex, setDeleteRowIndex] = useState<number>()

  const [isGridRefreshed, setIsGridRefreshed] = useState<boolean>(false)
  const [選択行, set選択行] = useState<wjcGrid.Row>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `乗務員出勤簿`
    // 初期表示生成のため画面ロック
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set区分ItemSource(区分マスタRes.data)
    })
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (!区分ItemSource) return
    setDataInitialized(true)
  }, [区分ItemSource])

  useEffect(() => {
    if (gridInitialized && dataInitialized) {
      // クエリパラメータで検索条件作成
      const querySearchCondition: TSyukkinboGetReq = {
        社員ID: parseInt(所属_社員ID),
        年月,
      }

      // リストア中フラグON
      setIsRestoreSearching(true)
      // 検索
      if (querySearchCondition != null) {
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      }
    }
  }, [gridInitialized, dataInitialized])

  useEffect(() => {
    if (!isGridRefreshed || !flexGrid || !有給残数) return

    setSummaryWorkingDayGridData(
      create勤務日数総計(flexGrid.collectionView.sourceCollection, 有給残数)
    )

    setIsGridRefreshed(false)
  }, [isGridRefreshed, flexGrid, 有給残数])

  useEffect(() => {
    if (flexGrid == null || isDigitachoEditModalShow) return

    setSummaryTimeGridData(
      create勤怠時間総計(flexGrid.collectionView.sourceCollection)
    )
  }, [isDigitachoEditModalShow, flexGrid])

  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">乗務員出勤簿(新)</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row className="justify-content-start">
          {/* 出勤簿 */}
          <Col className="d-flex">
            <Card className="min-w-40rem">
              <Card.Body>
                <Container fluid className="label-form">
                  {/* 年月 */}
                  <LabelFormRow
                    label="年月"
                    positionClassName="d-flex"
                    labelWidth={6}>
                    <TextInput
                      style={{ width: "6rem" }}
                      id="年月"
                      name="年月"
                      value={dayjs(年月).format("YYYY/MM")}
                      setValue={() => {}}
                      isReadOnly></TextInput>
                  </LabelFormRow>
                  {/* 部所 */}
                  <LabelFormRow
                    label="部所"
                    positionClassName="d-flex"
                    labelWidth={6}>
                    <TextInput
                      style={{ width: "20rem" }}
                      id="部所名"
                      name="部所名"
                      value={部所名}
                      setValue={() => {}}
                      isReadOnly></TextInput>
                  </LabelFormRow>
                  {/* 氏名 */}
                  <LabelFormRow
                    label="氏名"
                    positionClassName="d-flex"
                    labelWidth={6}>
                    <div className="d-flex">
                      <TextInput
                        style={{ width: "6rem" }}
                        id="社員番号"
                        name="社員番号"
                        value={社員番号}
                        setValue={() => {}}
                        isReadOnly></TextInput>
                      <TextInput
                        id="氏名"
                        name="氏名"
                        value={氏名}
                        setValue={() => {}}
                        isReadOnly></TextInput>
                    </div>
                  </LabelFormRow>
                </Container>
              </Card.Body>
            </Card>
            <Card className="ms-3 min-w-30rem">
              <Card.Body>
                <SummaryTimeGrid
                  kintaiSummaryData={summaryTimeGridData}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                />
              </Card.Body>
            </Card>
            <Card className="ms-3 min-w-30rem">
              <Card.Body>
                <SummaryWorkingDayGrid
                  kintaiSummaryData={summaryWorkingDayGridData}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            {/* カレンダー部分 */}
            <Row>
              <Col>
                {/* 検索結果カード */}
                <Card>
                  <Spinner searching={isSearching}></Spinner>
                  <Card.Body>
                    {dataInitialized && (
                      <FlexGridOuter
                        flexGrid={flexGrid}
                        setFlexGrid={setFlexGrid}
                        gridConstantProperties={
                          CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        }
                        gridData={gridData}
                        setGridData={setGridData}
                        pageNumber={pageNumber}
                        gridId={`${gridId}_1`}
                        isRestoreSearching={isRestoreSearching}
                        setIsRestoreSearching={setIsRestoreSearching}
                        gridInitialized={gridInitialized}
                        setGridInitialized={setGridInitialized}
                        isShowGridFooter={true}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        gridInitializedHandler={gridInitializedHandler}
                        isShowGridRowPickupButton={false}
                        style={{ maxHeight: "Auto" }}
                        isEnablePageSize={"hidden"}
                        hasFilter={false}
                        headerComponent={
                          <>
                            <Button
                              variant="waiting"
                              onClick={() => {
                                beforeSubmit()
                              }}>
                              更新
                            </Button>
                            <Button
                              type="button"
                              className="ms-4"
                              onClick={() => addNewRow()}>
                              <FontAwesomeIcon icon={faPlusSquare} />
                              選択行追加
                            </Button>
                            {history.length > 1 && (
                              <Button
                                type="button"
                                variant="secondary"
                                className="ms-4"
                                onClick={() => history.goBack()}>
                                一覧に戻る
                              </Button>
                            )}
                          </>
                        }
                        gridProperties={{
                          headersVisibility: wjcGrid.HeadersVisibility.Column,
                          allowAddNew: false,
                          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
                          allowSorting: wjcGrid.AllowSorting.None,
                          allowDragging: wjcGrid.AllowDragging.None,
                          selectionMode: wjcGrid.SelectionMode.Cell,
                          stickyHeaders: true,
                          frozenColumns: 2,
                        }}
                        excelFormatItem={乗務員出勤簿ExcelFormat}
                        pdfFormatItem={乗務員出勤簿PdfFormat}>
                        <wjrGrid.FlexGridColumn
                          binding="勤務日"
                          width={40}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          header="日">
                          <wjrGrid.FlexGridCellTemplate
                            cellType="Cell"
                            template={(
                              context: TWijmoCellTemplateContext<TZyomuinHibetuKintai>
                            ) => {
                              // 休日判定
                              let holidayCssClass = ""

                              // 休日マスタとの判定
                              if (
                                dayjs(context.item.勤務日).format("dd") ===
                                  "日" ||
                                holidayList.find(
                                  (i) =>
                                    dayjs(context.item.勤務日).format(
                                      "YYYYMMDD"
                                    ) === dayjs(i.休日).format("YYYYMMDD")
                                )
                              ) {
                                holidayCssClass = "holiday-color"
                              }
                              if (
                                holidayCssClass === "" &&
                                syoteiHolidayList.find(
                                  (i) =>
                                    dayjs(context.item.勤務日).format(
                                      "YYYYMMDD"
                                    ) === dayjs(i.休日).format("YYYYMMDD")
                                )
                              ) {
                                holidayCssClass = "syukkinbo-holiday-color"
                              }
                              return (
                                <span className={`${holidayCssClass}`}>
                                  {dayjs(context.item.勤務日).format("DD")}
                                </span>
                              )
                            }}
                          />
                        </wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="曜日"
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={40}
                          header="曜日">
                          <wjrGrid.FlexGridCellTemplate
                            cellType="Cell"
                            template={(
                              context: TWijmoCellTemplateContext<TZyomuinHibetuKintai>
                            ) => {
                              // 休日判定
                              let holidayCssClass = ""

                              // 休日マスタとの判定
                              if (
                                dayjs(context.item.勤務日).format("dd") ===
                                  "日" ||
                                holidayList.find(
                                  (i) =>
                                    dayjs(context.item.勤務日).format(
                                      "YYYYMMDD"
                                    ) === dayjs(i.休日).format("YYYYMMDD")
                                )
                              ) {
                                holidayCssClass = "holiday-color"
                              }
                              if (
                                holidayCssClass === "" &&
                                syoteiHolidayList.find(
                                  (i) =>
                                    dayjs(context.item.勤務日).format(
                                      "YYYYMMDD"
                                    ) === dayjs(i.休日).format("YYYYMMDD")
                                )
                              ) {
                                holidayCssClass = "syukkinbo-holiday-color"
                              }

                              return (
                                <span className={`${holidayCssClass}`}>
                                  {dayjs(context.item.勤務日).format("ddd")}
                                </span>
                              )
                            }}
                          />
                        </wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="勤怠区分コード"
                          width={90}
                          dataMap={
                            new wjcGrid.DataMap(
                              create勤務区分ItemSource(区分ItemSource),
                              "区分コード",
                              "名称1"
                            )
                          }
                          isRequired={false}
                          header="勤務"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="タイムカード出勤時刻"
                          width={65}
                          isRequired={false}
                          header="出勤"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="タイムカード退勤時刻"
                          isRequired={false}
                          width={65}
                          header="退勤"></wjrGrid.FlexGridColumn>
                        {/* デジタコ情報 */}
                        <wjrGrid.FlexGridColumn
                          binding="str始業時刻"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="始業"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str終業時刻"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="終業"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str勤務時間"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="勤務"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str残業時間"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="残業"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str深夜時間"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="深夜"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str休出時間"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="休出"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str拘束時間"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="拘束"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str休憩時間"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="休憩"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="str休息時間"
                          isRequired={false}
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          width={65}
                          header="休息"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="労務警告文字"
                          isReadOnly={true}
                          cssClass={"read-only-cell"}
                          wordWrap={true}
                          width={50}
                          header="労務警告">
                          <wjrGrid.FlexGridCellTemplate
                            cellType="Cell"
                            template={(
                              context: TWijmoCellTemplateContext<
                                T勤怠リスト & { 労務警告文字?: string }
                              >
                            ) => {
                              const 労務警告文字 =
                                context?.item?.労務警告文字 ?? ""
                              return (
                                労務警告文字 !== "" && (
                                  <button
                                    className="link-button text-dark fw-bold"
                                    onClick={roumuKeikokuButtonClickHandler(
                                      context
                                    )}>
                                    {労務警告文字}
                                  </button>
                                )
                              )
                            }}
                          />
                        </wjrGrid.FlexGridColumn>

                        <wjrGrid.FlexGridColumn
                          binding="修正フラグ"
                          isReadOnly={true}
                          wordWrap={true}
                          cssClass={"read-only-cell"}
                          width={50}
                          header="修正">
                          <wjrGrid.FlexGridCellTemplate
                            cellType="Cell"
                            template={(
                              context: TWijmoCellTemplateContext<T勤怠リスト>
                            ) => {
                              return (
                                context.item.削除フラグ !== 1 && (
                                  <button
                                    className="link-button text-primary"
                                    onClick={editButtonClickHandler(context)}>
                                    ■
                                  </button>
                                )
                              )
                            }}
                          />
                        </wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="備考"
                          cssClass="text-start"
                          isRequired={false}
                          width={200}
                          header="備考"></wjrGrid.FlexGridColumn>
                        <wjrGrid.FlexGridColumn
                          binding="日別勤怠ID"
                          isRequired={false}
                          isReadOnly={true}
                          width={80}
                          header="削除">
                          <wjrGrid.FlexGridCellTemplate
                            cellType="Cell"
                            template={(
                              context: TWijmoCellTemplateContext<T勤怠リスト>
                            ) => {
                              if (context.item.複数行フラグ === 1) {
                                return context.item.削除フラグ === 1 ? (
                                  <Button
                                    type="button"
                                    variant={"pending"}
                                    className="btn btn-small btn-primary move-edit-page"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      context.item.削除フラグ = 0
                                      context.row.grid?.refresh()
                                    }}>
                                    解除
                                  </Button>
                                ) : (
                                  <Button
                                    type="button"
                                    variant={"caution"}
                                    className="btn btn-small btn-primary move-edit-page"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      context.item.削除フラグ = 1
                                      context.row.grid?.refresh()
                                    }}>
                                    削除
                                  </Button>
                                )
                              } else if (context.item.複数行フラグ === 2) {
                                return (
                                  <Button
                                    type="button"
                                    variant="caution"
                                    className="btn btn-small btn-primary move-edit-page"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      setDeleteRowIndex(context.row.index)
                                      setIsDeleteNewRowConfirmModalShow(true)
                                    }}>
                                    削除
                                  </Button>
                                )
                              } else {
                                return <></>
                              }
                            }}
                          />
                        </wjrGrid.FlexGridColumn>
                      </FlexGridOuter>
                    )}
                    <>
                      <Button
                        className="mx-1"
                        variant="waiting"
                        onClick={() => {
                          beforeSubmit()
                        }}>
                        更新
                      </Button>
                      <Button
                        type="button"
                        variant="secondary"
                        className="ms-4"
                        onClick={() => history.goBack()}>
                        一覧に戻る
                      </Button>
                    </>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col xs={4}>
            <Row>
              <Col>
                {/* デジタコ情報 */}
                <Card style={{ maxHeight: "75rem" }}>
                  <Card.Header>デジタコ情報</Card.Header>
                  <Spinner searching={isSearching}></Spinner>
                  <Card.Body>
                    <DigitachoGrid
                      isRestoreSearching={isRestoreSearching}
                      setIsRestoreSearching={setIsRestoreSearching}
                      digiTachoGridData={digiTachoGridData}
                      setDigiTachoGridData={setDigiTachoGridData}
                      gridId={gridId}
                      年月={年月}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                {/* タイムカード情報 */}
                <Card style={{ maxHeight: "75rem" }}>
                  <Card.Header>タイムカード情報</Card.Header>
                  <Spinner searching={isSearching}></Spinner>
                  <Card.Body>
                    <TimeCardGrid
                      isRestoreSearching={isRestoreSearching}
                      setIsRestoreSearching={setIsRestoreSearching}
                      dakokuGridData={dakokuGridData}
                      setDakokuGridData={setDakokuGridData}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>

      <DigitachoEditModal
        isShow={isDigitachoEditModalShow}
        setIsShow={setIsDigitachoEditModalShow}
        編集勤怠情報={編集勤怠情報}
        年月={年月}
        flexGrid={flexGrid}
        選択行={選択行}
        デジタコ勤怠GridData={digiTachoGridData?.data?.sourceCollection}
        kubunItemsSource={区分ItemSource}
        title={"勤労時間修正"}
      />

      <RoumuKeikokuModal
        isShow={is労務警告ModalShow}
        選択行={選択行}
        年月={年月}
        setIsShow={setIs労務警告ModalShow}
        title={"労務警告"}
      />
      <ConfirmModal
        isShow={isDeleteNewRowConfirmModalShow}
        hideHandler={setIsDeleteNewRowConfirmModalShow}
        submitHandler={deleteNewRow}>
        選択した新規行を削除しますか？
      </ConfirmModal>
    </>
  )
}

export default ZyomuinSyukkinbo
